import { render } from "./CheckUserIdentify.vue?vue&type=template&id=787c46c5&scoped=true&ts=true"
import script from "./CheckUserIdentify.vue?vue&type=script&lang=ts"
export * from "./CheckUserIdentify.vue?vue&type=script&lang=ts"

import "./CheckUserIdentify.vue?vue&type=style&index=0&id=787c46c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787c46c5"]])

export default __exports__